/**
 * ./exercise5/Exercise5Intro.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useEffect, useState } from "react";
import "../exercise1/Exercise1Intro.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
import IconBubble from "../components/IconBubble/IconBubble";
import Star2 from "../components/icons/star2.svg";
import { API_BASE_URL } from "../config";

const Exercise5Intro = () => {
  const [selectedDuration, setSelectedDuration] = useState(0.5); // Default to 1 minute
  const [canStart, setCanStart] = useState(false);
  const [sunnyHTML, setSunnyHTML] = useState(
    `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
    Exercise 5 will train your brain to understand disordered words and develop photographic reading.
  </span>`
  );
  const [userData, setUserData] = useState(null); // We added this
  const [bubbleHeight, setBubbleHeight] = useState(100);
  const navigate = useNavigate();

  const durations = [5, 10]; // List of durations

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        const data = await response.json();
        setUserData(data);

        // ✅ Automatically select the next available duration
        if (data.numExercisesUnlocked >= 1) {
          const nextUnlocked = durations.find(duration => duration >= data.currNumLevelsUnlocked);
          if (nextUnlocked) {
            setSelectedDuration(nextUnlocked);
          }
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  // We added this
  const isLevelUnlocked = (levelNumber) => {
    if (!userData) return false; // Assume locked if user data isn't loaded
    return userData.exercisesUnlocked[4] >= levelNumber;
  };


  const handleDurationClick = (duration) => {
    setSelectedDuration(duration);
  };

  const handleStartClick = () => {
    navigate("/exercise5workout", {
      state: {
        duration: selectedDuration, // Convert minutes to seconds
      },
    });
  };

  // const handleVideoClick = () => {
  //   navigate("/exercise5video");
  // };

  let handleNextNextClick = () => {
    setSunnyHTML(
`<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
As long as there's intuitive or associative understanding , you're on the right track.<br><br>

Repeat the exercise until you can:<br><br>

1. <b>maintain rhythmic breathing</b> 95% of the time<br>
2. <b>capture the words</b> 95% of the time<br>
3. <b>comprehend the words</b> 95% of the time<br><br>

Achieve these 3, and you can tackle the next exercise!
</span>`

    );
    setBubbleHeight(320);
    setCanStart(true);
  };

  let handleNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
      Maintain rhythmic breathing while trying to understand the disordered sentence.
    </span>`
    );
  };

  const renderButton = () => {
    if (canStart) {
      return (
        <button
          className="guidance-and-start-button"
          onClick={handleStartClick}
        >
          Start
        </button>
      );
    } else {
      return (
        <button
          className="guidance-and-start-button"
          onClick={
            sunnyHTML.includes("Exercise 5")
              ? handleNextClick
              : handleNextNextClick
          }
        >
          Next
        </button>
      );
    }
  };

  return (
    <div className="exercise1-intro-container">
      <div className="intro-content">
        <div className="duration-selection">
          <div className="durations">
            {durations.map((duration, index) => (
              <button
                key={duration}
                className={`duration-button ${
                  selectedDuration === duration ? "selected" : ""
                }`}
                onClick={() => handleDurationClick(duration)}
                disabled={!isLevelUnlocked(index + 1)}
                style={{
                  backgroundColor: isLevelUnlocked(index + 1)
                    ? "#4CAF50"
                    : "#CCCCCC",
                  cursor: isLevelUnlocked(index + 1) ? "pointer" : "not-allowed",
                }}
              >
                {duration}
              </button>
            ))}
          </div>
        </div>
        <p className="hint">Hint: Complete levels to unlock more</p>
      </div>
      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble
          width={620}
          height={bubbleHeight}
          HTML={sunnyHTML}
          color="FFFFFF"
          fontSize={25}
        />
      </div>
      <div className="bottom-buttons">
        <div></div>
        {/* <button
          className="guidance-and-start-button"
          onClick={handleVideoClick}
        >
          Guidance Video
        </button> */}
        {renderButton()}
      </div>
    </div>
  );
};

export default Exercise5Intro;
